var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from "react";
import { Segmented } from "antd";
import { CompsChart } from "@ms/shared-components";
import { COMMON_CHART_SETTINGS } from "../RoomStatusRecently/config/index";
import { AXIS_LABEL_INTEGER } from "../../configs/tooltipCommon";
import { EmptyDataPlaceholder } from "../EmptyDataPlaceholder";
import { pickOperationEfficiencyChart, } from "../../hooks/useOperationEfficiencyData";
var DEFAULT_CHART_DATA = {
    categories: [],
    dataset: {
        earlyCheckout: [],
        noshow: [],
        orderTake: [],
        ratio: [],
    },
    axes: {
        left: {
            id: "left",
            position: "left",
            name: "数量",
            unit: "间",
            min: 0,
            max: 100,
            axisLabel: AXIS_LABEL_INTEGER,
        },
        right: {
            id: "right",
            position: "right",
            name: "非正常占比",
            unit: "%",
            min: 0,
            max: 100,
            axisLabel: AXIS_LABEL_INTEGER,
        },
    },
    series: [],
};
var OperationEfficiency = function (_a) {
    var style = _a.style, bundle = _a.bundle, _b = _a.loading, loading = _b === void 0 ? false : _b, onTitleClick = _a.onTitleClick, titleLeftAdornment = _a.titleLeftAdornment;
    var _c = useState("7d"), range = _c[0], setRange = _c[1];
    var chartData = useMemo(function () {
        var _a;
        var raw = (_a = pickOperationEfficiencyChart(bundle, range)) !== null && _a !== void 0 ? _a : DEFAULT_CHART_DATA;
        if (!(raw === null || raw === void 0 ? void 0 : raw.axes))
            return raw;
        var axes = raw.axes;
        var withLabel = function (ax) {
            return ax && typeof ax === "object"
                ? __assign(__assign({}, ax), { axisLabel: AXIS_LABEL_INTEGER }) : ax;
        };
        return __assign(__assign({}, raw), { axes: Object.fromEntries(Object.entries(axes).map(function (_a) {
                var k = _a[0], v = _a[1];
                return [k, withLabel(v)];
            })) });
    }, [bundle, range]);
    var hasChartData = chartData &&
        Array.isArray(chartData.series) &&
        chartData.series.length > 0 &&
        Array.isArray(chartData.categories) &&
        chartData.categories.length > 0;
    return (_jsxs("div", __assign({ "data-component-id": "chart:operation-efficiency", style: __assign({ display: "flex", flexDirection: "column", width: 400, height: 300, border: "1px solid #f0f0f0", borderRadius: 4, background: "#fafafa", boxSizing: "border-box", overflow: "visible", flexShrink: 0 }, style) }, { children: [_jsxs("div", __assign({ style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    borderBottom: "1px solid #f0f0f0",
                    background: "#fff",
                    flexShrink: 0,
                    flexWrap: "wrap",
                    gap: 8,
                } }, { children: [_jsxs("div", __assign({ style: { display: "flex", alignItems: "center", flexShrink: 0, minWidth: 0 } }, { children: [titleLeftAdornment && (_jsx("div", __assign({ style: {
                                    marginLeft: -4,
                                    marginRight: 4,
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                } }, { children: titleLeftAdornment }))), onTitleClick ? (_jsx("button", __assign({ type: "button", onClick: onTitleClick, style: {
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: "#333",
                                    cursor: "pointer",
                                    padding: 0,
                                    border: "none",
                                    background: "none",
                                }, title: "\u70B9\u51FB\u67E5\u770B\u8FD0\u8425\u6548\u7387" }, { children: "\u8FD0\u8425\u6548\u7387" }))) : (_jsx("div", __assign({ style: { fontSize: 14, fontWeight: 500, color: "#333" } }, { children: "\u8FD0\u8425\u6548\u7387" })))] })), _jsx(Segmented, { size: "small", value: range, onChange: function (v) { return setRange(v); }, options: [
                            { label: "过去7天", value: "7d" },
                            { label: "过去30天", value: "30d" },
                            { label: "过去12个月", value: "12m" },
                            { label: "未来7天", value: "next7d" },
                            { label: "未来30天", value: "next30d" },
                        ] })] })), _jsxs("div", __assign({ style: {
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    padding: 0,
                    boxSizing: "border-box",
                    overflow: "visible",
                    position: "relative",
                    display: "flex",
                    height: "100%",
                    background: "#fff",
                } }, { children: [loading && _jsx(EmptyDataPlaceholder, { description: "\u52A0\u8F7D\u4E2D..." }), !loading && hasChartData && (_jsx(CompsChart, { type: "combo", data: chartData, settings: COMMON_CHART_SETTINGS, style: { width: "100%", height: "100%" } })), !loading && !hasChartData && (_jsx(EmptyDataPlaceholder, { description: "\u6682\u65E0\u6570\u636E" }))] }))] })));
};
export default OperationEfficiency;
